<template>
  <div v-if="filteredStudentList" class="setting-seat">
    <div ref="map">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="downloadPDF()">{{ $t('common.export_pdf') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <SeatMap @saveSeatAction="saveAction" :studentList="filteredStudentList"
          :seatMap="busInfo.seat_map" :layoutInfo="busInfo.layout_info"></SeatMap>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'
  import { forceDownloadFile } from "../../utils";
  import SeatMap from "../BusLayout/SeatMap";

  export default {
    name: "SettingSeat",
    components: {
      SeatMap,
      PageTitle
    },
    data: function () {
      return {
        title: 'common.setting_seats',
        backLink: '',
        bus_id: this.$route.query.bid,
        type: '',
        studentList: [],
        busInfo: null,
        studentListForBus: [],
        isCloned: false,
        isBusInfoLoaded: false,
        isStudentListLoaded: false
      }
    },
    mounted: function () {
      let busInfoPayload = {
        successCallback: (response) => {
          this.busInfo = Object.assign({}, response.data.data.bus_info)
          if (this.busInfo.layout_id === null) this.busInfo.layout_id = ""

          if (this.busInfo.seat_map === null) {
            this.busInfo.seat_map = []
          }

          this.busInfo.seat_map = [].concat(this.busInfo.seat_map)
          this.isBusInfoLoaded = true
        },
        bus_id: this.$route.query.bid
      }

      this.$store.dispatch('bus/getBusInfo', busInfoPayload)

      let studentListPayload = {
        successCallback: (response) => {
          this.studentList = [].concat(response.data.data.student_list)
          this.isStudentListLoaded = true
        },
        bus_id: this.$route.query.bid
      }

      this.$store.dispatch('bus/getStudentListForBus', studentListPayload)
      this.backLink = this.adminLoggedInfo.role === 2 ? `/parent/select-bus` : `/bus/detail?bid=${this.$route.query.bid}`
      this.type = this.adminLoggedInfo.role === 3 ? 'admin' : 'parent'
    },
    computed: {
      ...mapState('pickuproute', ['parentPickupRouteList']),
      ...mapState('login', ['adminLoggedInfo']),
      // ready: function () {
      //
      // },
      filteredStudentList: function () {
        if (this.isBusInfoLoaded && this.isStudentListLoaded) {
          let filteredStudentList = [].concat(this.studentList).map((item) => {
            item.isHide = false
            return item
          })

          this.busInfo.seat_map.forEach((row) => {
            row.forEach((cell) => {
              if (cell && cell.id) {
                let student = filteredStudentList.find((item) => item.id === cell.id)

                if (student) {
                  student.isHide = true
                }
              }
            })
          })

          return filteredStudentList
        }

        return null
      }
    },
    methods: {
      saveAction: function (e) {
        let payload = {
          bus_id: this.$route.query.bid,
          seat_map: e.list_seat,
          successCallback: () => {
            this.$store.commit('openNotification', {
              type: 'success',
              message: this.$t('common.success')
            })
          }
        }
        this.$store.dispatch('bus/updateBusSeatMap', payload)
      },
      downloadPDF: function () {
        this.$store.dispatch('bus/exportBusSeatMap', {
          bus_id: this.busInfo.id,
          lang: this.$i18n.locale,
          successCallback: (response) => {
            forceDownloadFile(response.data.data.url, response.data.data.name)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
</style>
